import Color from 'color';
import { useWidgetContext } from 'widget/widget-context';

const useIsPrimaryDark = () => {
  const { widget } = useWidgetContext();
  const { colors } = widget;

  return Color(colors.primary).darken(0.4).isDark();
};

export default useIsPrimaryDark;
